<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">USERS</h1>
                </v-col>
                <v-col :cols="6" class="text-right"> </v-col>
            </v-row>
        </v-container>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    dark
                    small
                    rounded
                    class="mb-2"
                    @click="add_users()"
                    ><v-icon small class="mr-1">mdi-plus</v-icon>Create
                    New</v-btn
                >
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="data_user"
                :search="search"
                :loading="isLoading"
                loading-text="Loading... Please wait"
            >
                <template v-slot:[`item.btn`]="{ item }">
                    <v-icon small class="mr-2" @click="edit(item)">
                        mdi-square-edit-outline
                    </v-icon>
                    <v-icon small @click="del(item.id)">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="Name"
                                    v-model="new_user.name"
                                    :rules="nameR"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="Password"
                                    type="password"
                                    v-model="new_user.password"
                                    :rules="passwordR"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="Email"
                                    v-model="new_user.email"
                                    :rules="emailR"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="new_user.team_id"
                                    :items="data_team"
                                    item-text="team_name"
                                    item-value="team_id"
                                    menu-props="auto"
                                    label="Team"
                                    hide-details
                                    single-line
                                    @change="get_role(new_user.team_id)"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="new_user.role_id"
                                    :items="data_role"
                                    item-text="role_name"
                                    item-value="role_id"
                                    menu-props="auto"
                                    label="Role"
                                    hide-details
                                    single-line
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="HP Learner ID"
                                    v-model="new_user.hp_learnerid"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="CDAX Owner ID"
                                    v-model="new_user.cdax_ownerid"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field
                                    label="HP Site ID"
                                    v-model="new_user.hp_siteid"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save(new_user.id)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div id="snackbar">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url_team = `${process.env.VUE_APP_ROOT_API}/api/team/`
export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.chk_url()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async chk_url() {
            let send = {
                url: this.$route.path,
            }
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/` + "check-auth",
                    send,
                    this.tk
                )
                .then((response) => {
                    if (response.data.status == "error") {
                        this.$root.$router.push({
                            path: "/404",
                        })
                    } else {
                        this.get_user()
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_user() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/users/`
            let { data } = await axios.get(url)
            this.data_user = data
        },
        add_users() {
            this.get_team()
            this.formTitle = "New User"
            this.new_user = { ...this.usr }
            this.dialog = true
        },
        close() {
            this.get_user()
            this.dialog = false
        },
        async save(id) {
            let data_new_user = { ...this.new_user }
            // console.log(data_new_user)
            let url = `${process.env.VUE_APP_ROOT_API}/api/users/`
            if (this.formTitle == "New User") {
                await axios.post(url, data_new_user)
            } else if (this.formTitle == "Edit User") {
                try {
                    await axios.put(url + id, data_new_user)
                } catch (error) {
                    console.log(error)
                }
            }
            this.mutatesnackbar()
            this.close()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                    this.snackbar
                }, 2000)
            }
        },
        async edit(data) {
            this.formTitle = "Edit User"
            this.new_user = data
            // console.log(this.new_user, "newuser")
            await this.get_team()
            if (this.new_user.team_id != null) {
                this.get_role(this.new_user.team_id)
            }
            this.dialog = true
        },
        async del(id) {
            let url = `${process.env.VUE_APP_ROOT_API}/api/users/` + id
            if (confirm("Are you sure you want to delete this project?")) {
                try {
                    await axios.delete(url)
                    this.get_user()
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async get_team() {
            let { data } = await axios.get(url_team)
            this.data_team = data
        },
        async get_role(id_team) {
            let { data } = await axios.get(url_team + id_team)
            this.data_role = data[0].role
        },
    },
    data() {
        return {
            tk: null,
            headers: [
                {
                    text: "Name",
                    value: "name",
                },
                {
                    text: "Email",
                    value: "email",
                },
                {
                    text: "Team",
                    value: "team_name",
                },
                {
                    text: "Role",
                    value: "role_name",
                },
                {
                    text: "Action",
                    value: "btn",
                },
            ],
            data_user: [],
            data_team: [],
            data_role: [],
            search: "",
            dialog: false,
            formTitle: "",
            usr: {
                name: "",
                password: "",
                email: "",
                team_id: "",
                role_id: "",
                hp_learnerid: "",
                cdax_ownerid: "",
                hp_siteid: "",
            },
            new_user: {
                name: "",
                password: "",
                email: "",
                team_id: "",
                role_id: "",
                hp_learnerid: "",
                cdax_ownerid: "",
                hp_siteid: "",
            },
            text: "Success, Your work has been saved",
            nameR: [(v) => !!v || "Name is required"],
            passwordR: [(v) => !!v || "Password is required"],
            emailR: [
                (v) => !!v || "E-mail is required",
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "E-mail must be valid",
            ],
        }
    },
}
</script>
